import Api from '@/api/Api'

class Auth extends Api {
  public async authenticate<T>(credential: Credentials) {
    const { data, error, response } = await this.fetch('auth/token').post(credential).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async register<T>(registerRequest: RegisterRequest) {
    const { data, error, response } = await this.fetch('register').post(registerRequest).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async forgotPassword<T>(email: string) {
    const { data, error, response } = await this.fetch('forgot-password').post({ email }).json<T>()

    return this.handleResponse(data.value, error.value, response.value?.status)
  }

  public async resetPassword<T>(resetPasswordRequest: ResetPasswordRequest) {
    const { data, error, response } = await this.fetch('reset-password')
      .post(resetPasswordRequest)
      .json<T>()

    return this.handleResponse(data.value, error.value, response.value?.status)
  }

  public async updateUserProfile<T>(request: UpdateUserProfileRequest) {
    const { data, error, response } = await this.fetch('account/update-profile').put(request).json()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async updateProfilePicture<T>(request: FormData) {
    const { data, error, response } = await this.fetch('account/update-profile-picture')
      .post(request)
      .formData()
      .json()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async deleteProfilePicture<T>() {
    const { data, error, response } = await this.fetch('account/delete-profile-picture')
      .delete()
      .json()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async getUserProfile<T>() {
    const { data, error, response } = await this.fetch('auth/profile').get().json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async sendVerificationEmail<T>() {
    const { data, error, response } = await this.fetch('verify-email').post().json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async verifyEmail<T>() {
    const { data, error, response } = await this.fetch('verify-email').get().json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async googleAuth<T>(request: GoogleAuthRequest) {
    const { data, error, response } = await this.fetch('google-auth').post(request).json<T>()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new Auth()
